/**
 * Utility that determines the decoded query parameter value from the given URL
 * @param {string} parameterName The name of the query parameter
 * @param {string} url The request URL
 * @param {string} defaultValue The default value
 * @returns {string} The value of the query parameter if not null else default value
 */
export function getOrDefaultQueryParameter(parameterName, url, defaultValue) {
    const match = RegExp('[?&]' + parameterName + '(=([^&#]*)|&|#|$)').exec(url);
    const parameterValue = match && decodeURIComponent(match[2].replace(/\+/g, ' '));
    return parameterValue ? parameterValue : defaultValue;
}

/**
 * Utility that determines if the provided string is blank
 * @param {string} str Input string
 * @returns {boolean} Is the string blank
 */
export function isBlankString(str) {
    return !str || 0 == str.trim().length;
}
/**
* Utility to load script in async
* @param {string} src Source Url
*/
export const loadScript = async(src) => {
  let s = document.createElement('script');
  s.async = false;
  s.src = src;

  return new Promise((resolve, reject) => {
    s.onload = s.onreadystatechange = () => {
      if (!s.readyState || /loaded|complete/.test(s.readyState)) {
        s.onload = s.onreadystatechange = null;
        s = undefined;
        resolve();
      }
    };

    s.onerror = () => {
      reject();
    };

    document.body.appendChild(s);
  });
}



// WEBPACK FOOTER //
// ./src/utils/commonUtil.js